import React from 'react'
import { Trans } from '@lingui/macro'

export const QuizElementType = {
  QUIZ_SINGLE: <Trans>Select one correct answer</Trans>,
  QUIZ_MULTI: <Trans>Select the multiple correct answers</Trans>,
  QUIZ_OPEN: (
    <Trans>Select one or more, there are no correct/incorrect answers</Trans>
  ),
  QUIZ_FREE: <Trans>Open text</Trans>
}

export const QuizElementTypeShort = {
  QUIZ_SINGLE: <Trans>Single select</Trans>,
  QUIZ_MULTI: <Trans>Multi select</Trans>,
  QUIZ_OPEN: <Trans>Open</Trans>,
  QUIZ_FREE: <Trans>Free text</Trans>
}
